import * as Actions from "../../actions/app"

const initialState = {
  loading_update_serie: false,
  updated_serie: false,

  loading_series_related: false,
  series_related: null,
}

const seriesProductReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.UPDATE_SERIE_PRODUCT: {
      return {
        ...state,
        loading_update_serie: action.payload.loading,
        updated_serie: action.payload.updated
      }
    }

    case Actions.GET_SERIES_RELATED: {
      return {
        ...state,
        loading_series_related: action.payload.loading,
        series_related: action.payload.data
      }
    }

    default: {
      return state
    }
  }
}
export default seriesProductReducer
